module.exports = __webpack_public_path__ + "87d631faa7ac11e6f4285e98d6dd3112.svg";